import axiosInstance from "axios";

function convertToFormData(object) {
  const formData = new FormData();
  for (const key in object) {
    if (Object.hasOwnProperty.call(object, key)) {
      const element = object[key];
      console.log({ element, key });
      if (element !== null && element !== undefined) {
        formData.append(key, element);
      }
    }
  }
  console.log({ formData });
  return formData;
}

class Http {
  get = (url, params, otherConfig) => {
    return axiosInstance({
      method: "get",
      url: url,
      params,
      ...otherConfig,
    });
  };

  delete = (url, params, otherConfig) => {
    return axiosInstance({
      method: "delete",
      url: url,
      params,
      ...otherConfig,
    });
  };

  getFileBlob = (url, params) => {
    return axiosInstance({
      method: "get",
      url: url,
      params,
      responseType: "blob",
    });
  };

  post = (url, data) => {
    return axiosInstance({
      method: "post",
      url: url,
      data,
    });
  };
  postForm = (url, data) => {
    return axiosInstance({
      method: "post",
      url: url,
      data: convertToFormData(data),
    });
  };
}
export default Http;
